import { CommonMessage } from '@frontend/lang';
import { SlotStatus } from '@frontend/slot/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import useSlotStatusBadge from './slot-status-badge.controller';

const ID = 'slot-status-badge';

const SLOT_STATUS_MESSAGES: Record<SlotStatus, React.ReactNode> = {
    [SlotStatus.AVAILABLE]: (
        <FormattedMessage
            id='SlotStatus.available'
            description='The displayed value for the SlotStatus available'
            defaultMessage='Available' />
    ),
    [SlotStatus.BROKEN]: (
        <FormattedMessage
            id='SlotStatus.broken'
            description='The displayed value for the SlotStatus broken'
            defaultMessage='Broken' />
    ),
    [SlotStatus.MERGED]: (
        <FormattedMessage
            id='SlotStatus.merged'
            description='The displayed value for the SlotStatus merged'
            defaultMessage='Merged' />
    ),
    [SlotStatus.NOT_AVAILABLE]: (
        <FormattedMessage
            id='SlotStatus.not_available'
            description='The displayed value for the SlotStatus not available'
            defaultMessage='Not available' />
    ),
    [SlotStatus.NON_FUNCTIONAL]: (
        <FormattedMessage
            id='SlotStatus.non_functional'
            description='The displayed value for the SlotStatus non functional'
            defaultMessage='Non functional' />
    ),
};

export interface SlotStatusBadgeProps {
    status: SlotStatus | null;
}

export const SlotStatusBadge = (props: SlotStatusBadgeProps) => {
    const viewProps = useSlotStatusBadge(props);
    const label = props.status
        ? SLOT_STATUS_MESSAGES[props.status] ?? props.status.replace(/_/g, ' ')
        : CommonMessage.OBJECTS.UNKNOWN.DEFAULT;
    return (
        <span
            id={ID}
            className={`inline-flex items-start justify-center gap-2 rounded-full px-2 py-1 ${viewProps.className} `}>
            <div className='text-background-surface justify-start text-center text-sm font-semibold'>
                {label}
            </div>
        </span>
    );
};
